import React from 'react';
import classNames from 'classnames';
import $ from 'jquery';
import gsap from 'gsap';
import { pingAnalyticsUrl} from '../../../actions/actions';
import Wreath from '../Wreath/Wreath';
import ticketFan from '../../../images/scene--intro/ticket-fan.png';
import logo from '../../../images/scene--intro/holiday-games-logo.png';
import logoDesktop from '../../../images/scene--intro/holiday-games-logo--desktop.png';
import AllCards from '../../../images/tickets/AllCards.png';

const Intro = ({ view, changeView }) =>  {

  const introClass = classNames({
    'scene': true,
    'scene--intro': true,
    'scene--hidden': view !== 'intro'
  });

  const overflowVisible = {overflow:'visible'};

  return (
    <div className={introClass}>
        <div className="scene__content">
          <div className="scene__content-left">
            <img className="intro__holiday-logo" src={logoDesktop} alt="Holiday Games - Give the gift of games" />
            <p className="intro__description">Everyone knows Lottery tickets make the best Holiday gifts.</p>
            <p className="intro__description">Take the Virginia Lottery Gift Finder Quiz now to find the gift that’s best for you!</p>
            <a className="button button--white button--large" onClick={() => {pingAnalyticsUrl('953921'); return changeView('questions', view);}}>Start the Quiz</a>
          </div>
          <div className="scene__content-right">
          <svg onClick={() => changeView('questions', view)} className="wreath" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 793.3 819.9" style={{enableBackground:'new 0 0 793.3 819.9'}}>
            <Wreath view={view} changeView={changeView} />
          </svg>
          </div>
        </div>
    </div>
  );
}

export default Intro;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Intro/Intro.js
 **/